/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2025-04-28 13:25:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-04 09:43:45
 * @FilePath: /code/zeelool-nextjs/src/components/Product/ProductImageWithLenses.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Image from '@/components/Image';
import { set16ToRgba } from '@/utils/tools';
import { useEffect, useState } from 'react';

export interface ProductImageWithLensesProps {
  className?: string;
  imgUrl: string;
  // 优先采用叠加图（镜框+镜腿组合）
  blendFirst?: boolean;
  /** Force a standard accessory image instead of composing frame and lens layers. */
  forceAccessoryDisplay?: boolean;
  product: {
    background_image_of_mirror_leg?: string;
    frame_background_image?: string;
    [key: string]: any;
  };
  lens: {
    is_transparency_change?: number;
    color_no?: string;
    transparency?: string;
    polarized_light_transparency?: string;
    polarized_light_color_no?: string;
    is_consistent?: number; // 1单色 2渐变色
    [key: string]: any;
  };
}
const ProductImageWithLenses = ({
  className = '',
  product = {},
  lens = {},
  imgUrl = '',
  blendFirst = false,
  forceAccessoryDisplay = false,
}: ProductImageWithLensesProps) => {
  const legBg = product?.background_image_of_mirror_leg || '';
  const frameBg = product?.frame_background_image || '';
  const [showFrameBg, setShowFrameBg] = useState(false);
  const [isGradient, setIsGradient] = useState(false);
  const [frameColor, setFrameColor] = useState<string>('transparent');

  // Vue项目的逻辑
  const getImageUrl = () => {
    // 优先使用灰底图，没有再使用普通图片
    if (product.image?.product_gray && product.image.product_gray.length > 0) {
      return product.image.product_gray[0];
    } else {
      return product.image_gray || product.img || product.image || imgUrl; // 原图
    }
  };

  useEffect(() => {
    setIsGradient(lens?.is_transparency_change === 1);

    let bgTransparent = 'transparent';
    const frameData = lens || {};
    const {
      color_no = '',
      transparency = '0.00',
      polarized_light_transparency = '0.00',
      polarized_light_color_no = '',
      is_consistent = 1,
    } = frameData;
    const color2 = polarized_light_color_no || ''; // 渐变色
    const transparency2 = polarized_light_transparency || '0.00'; // 渐变色透明度

    if (color_no && transparency) {
      if (color2 !== '' && transparency2 !== '0.00' && is_consistent === 2) {
        bgTransparent = `linear-gradient(${set16ToRgba(color_no, transparency)}, ${set16ToRgba(color2, transparency2)})`;
      } else {
        bgTransparent = set16ToRgba(color_no, transparency);
      }
    }
    setShowFrameBg(!!legBg && !!frameBg && bgTransparent !== 'transparent');
    setFrameColor(bgTransparent);
  }, [lens]);

  const [animationDelay, setAnimationDelay] = useState(`-${new Date().valueOf() % 4000}ms`);

  if (forceAccessoryDisplay) {
    return (
      <Image
        className={`${className} object-cover`}
        src={imgUrl || getImageUrl()}
        alt="zeelool glasses"
        width={800}
        height={800}
      />
    );
  }

  if (blendFirst && legBg && frameBg) {
    return (
      <div className={`relative w-full h-auto ${className} !mix-blend-multiply`}>
        <Image
          className={`absolute top-0 left-0 block w-full h-auto z-4`}
          src={legBg}
          alt="zeelool glasses"
          width={800}
          height={400}
        />
        {showFrameBg && (
          <div
            className={`aspect-[2/1] relative z-5 ${isGradient ? 'TransitionFrameLensBg' : ''}`}
            // key={frameColor}
            style={{
              background: `${frameColor}`,
              animationDelay,
              border: '1px solid white',
            }}
            onAnimationStart={() => {
              setAnimationDelay(`-${new Date().valueOf() % 4000}ms`);
            }}
          />
        )}
        <Image
          className={`absolute top-0 left-0 block w-full h-auto z-6`}
          src={frameBg}
          alt="zeelool glasses"
          width={800}
          height={400}
        />
      </div>
    );
  }
  return (
    <>
      {/* TODO !mix-blend-multiply 这个是为了强制覆盖 购物车商品图没有判断 showFrameBg 的逻辑 */}
      {showFrameBg ? (
        <div className={`relative w-full h-auto ${className} !mix-blend-multiply`}>
          <Image
            className={`absolute top-0 left-0 block w-full h-auto z-4`}
            src={legBg}
            alt="zeelool glasses"
            width={800}
            height={400}
          />
          <div
            className={`aspect-[2/1] relative z-5 ${isGradient ? 'TransitionFrameLensBg' : ''}`}
            // key={frameColor}
            style={{
              background: `${frameColor}`,
              animationDelay,
              border: '1px solid white',
            }}
            onAnimationStart={() => {
              setAnimationDelay(`-${new Date().valueOf() % 4000}ms`);
            }}
          />
          <Image
            className={`absolute top-0 left-0 block w-full h-auto z-6`}
            src={frameBg}
            alt="zeelool glasses"
            width={800}
            height={400}
          />
        </div>
      ) : (
        <Image
          className={`${className} object-cover`}
          src={getImageUrl()}
          alt="zeelool glasses"
          width={800}
          height={product?.is_glass === 1 ? 400 : 800}
        />
      )}
    </>
  );
};

export default ProductImageWithLenses;
